import { Box } from "@mui/material";
import InternationalCollaboratorMap from "Explore/Components/InternationalCollaboratorMap";
import SectionTitle from "Explore/Components/SectionTitle";
import useExploreInfo from "Hooks/useExploreInfo";
import { useEffect, useState } from "react";
import {
  getUnitInternationalCollaboratorsByCountry,
  getUnitInternationalCollaboratorsById,
} from "Explore/Services/Unit";
import { TIME_FILTER_OPTIONS } from "Explore/Config/constraint";
import PublicIcon from "@mui/icons-material/Public";

const UnitInternationalCollaborators = () => {
  const { unit_id: id } = useExploreInfo();
  const [data, setData] = useState({ data: [], isLoading: true });
  const [countries, setCountries] = useState([]);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [timeFilter, setTimeFilter] = useState(TIME_FILTER_OPTIONS[1].value);

  useEffect(() => {
    if (!id) return;
    setData({ data: [], isLoading: true });
    getUnitInternationalCollaboratorsById({
      id,
      keyword: selectedKeywords,
      timeFilter,
    })
      .then((res) => {
        setData({ data: res?.results || [], isLoading: false });
      })
      .catch(() => {
        setData({ data: [], isLoading: false });
      });
  }, [id, JSON.stringify(selectedKeywords), timeFilter]);

  return (
    <Box>
      <SectionTitle
        title='Collaborators All Over the World'
        icon={<PublicIcon />}
      />
      <InternationalCollaboratorMap
        data={data.data}
        isLoading={data.isLoading}
        countries={countries}
        setCountries={setCountries}
        selectedKeywords={selectedKeywords}
        setSelectedKeywords={setSelectedKeywords}
        timeFilter={timeFilter}
        setTimeFilter={setTimeFilter}
        fetchFunction={({ id: countryId, page, rowsPerPage, keyword }) => {
          return getUnitInternationalCollaboratorsByCountry({
            id,
            country: countryId,
            keyword: keyword ?? selectedKeywords,
            page,
            rowsPerPage,
            timeFilter,
          });
        }}
      />
    </Box>
  );
};

export default UnitInternationalCollaborators;
